export default __webpack_public_path__ + "static/media/ic-success.1a9dd075.svg";